import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import surveyReducer from "./surveyReducer";
import adminSurveyReducer from "./adminSurveyReducer";
import eduReducer from "./eduReducer";
import vidReducer from "./vidReducer";
import applyReducer from "./applyReducer";
import messagesReducer from "./messagesReducer";

const store = configureStore({
  reducer: {
    auth: authReducer,
    survey: surveyReducer,
    adminSurvey: adminSurveyReducer,
    edu: eduReducer,
    vid: vidReducer,
    apply: applyReducer,
    messages: messagesReducer,
  },
});

export default store;
